import { lti as actions } from '../actions'
import { mergeDeepRight } from 'ramda'

// Reducers for
// store/action-methods/user.js
export const reducer = {}

reducer[actions.SET_LTI] = ({ state, action }) => {
  return mergeDeepRight(state, action.lti)
}
